import { InjectionToken } from '@angular/core';
import { TranslationConfigModel } from './translation-config.model';

export const TRANSLATION = new InjectionToken<TranslationConfigModel>('TRANSLATION');

const TRANSLATION_LANG_LOCALE_STORAGE_KEY = 'gulliver-lang';

export function setTranslationLang(lang: string, project: string) {
  localStorage.setItem(TRANSLATION_LANG_LOCALE_STORAGE_KEY + '-' + project, lang);
}

export function getTranslationLang(project: string) {
  return localStorage.getItem(TRANSLATION_LANG_LOCALE_STORAGE_KEY + '-' + project);
}
